module.exports = __webpack_public_path__ + "img/6-l.47ac7479.png";